import { createStyles, Divider, Grid, InputBase, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { SearchHeaderProps } from "./SearchHeader.types";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
            width: 250
        },
        iconButton: {
            padding: 10,
        },
        gridStyle: {
            marginTop: 16
        }
    }),
);

export const SearchHeader = ({ placeHolderText, setSearchQuery }: SearchHeaderProps) => {
    const classes = useStyles();
    return (
        <Grid className={classes.gridStyle} >
            <IconButton className={classes.iconButton} aria-label="search icon">
                <SearchIcon />
            </IconButton>
            <InputBase
                className={classes.input}
                placeholder={placeHolderText}
                inputProps={{ 'aria-label': placeHolderText }}
                onChange={event => setSearchQuery(event.target.value)}
            />
            <Divider />
        </Grid>
    );
};
